import { useState } from 'react';
import { useSession } from '../auth/AuthProvider';
import { roleLabel } from '../labels';

/**
 * The `select-org` screen: the caller belongs to several organizations and the server minted no
 * token until one is chosen. /auth/refresh returns 200 with a NULL accessToken here, so treating
 * "200 ⇒ signed in" as truth would spin forever on an empty screen.
 */
export function OrgPicker() {
  const { auth, selectOrg } = useSession();
  const [busy, setBusy] = useState(false);

  return (
    <div className="huaca-card" data-testid="org-picker">
      <h1>בחירת ארגון</h1>
      <ul className="huaca-list">
        {(auth?.orgs ?? []).map((o) => (
          <li key={o.id}>
            <button
              type="button"
              disabled={busy}
              data-testid={`pick-org-${o.id}`}
              onClick={() => {
                setBusy(true);
                void selectOrg(o.id).finally(() => setBusy(false));
              }}
            >
              {o.name} <span>({roleLabel(o.rootRole)})</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
